import Vue from "vue";
import i18n from './i18n'
import { extend, configure, ValidationProvider, ValidationObserver } from "vee-validate";

//NOTE - For more rules!
//LINK - https://vee-validate.logaretm.com/v3/guide/rules.html#importing-rules-in-nuxt-js
import { required, email, min, min_value, max_value, length, } from "vee-validate/dist/rules";
extend('required', required)
extend('email', email)
extend('min', min)
extend('min_value', min_value)
extend('max_value', max_value)
extend('length', length)
// extend('requiredIf', requiredIf)

configure({
  defaultMessage: (field, values) => {
    const translated_field = i18n.t(field)
    return i18n.t(`validation.${values._rule_}`, { attribute: translated_field, ...values })
  }
})


Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);